<template>
  <view class="toast-with-mask-demo">
    <cube-button  bindclick="clickToast">Toast - with mask</cube-button>
    <cube-toast

      txt="遮罩层"
      mask="{{ true }}"
      maskFadeTransition="{{ true }}"
      wx:ref="toast">
    </cube-toast>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    methods: {
      clickToast() {
        this.$refs.toast.show()
      }
    }
  })
</script>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-toast": "@mpxjs/mpx-cube-ui/src/components/toast/index"
    }
  }
</script>
